import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
const UpdateTemplateDashboardController = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTemplateDashboardController.url(args, options),
    method: 'put',
})

UpdateTemplateDashboardController.definition = {
    methods: ["put"],
    url: '/api/template-dashboard/{template_dashboard}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
UpdateTemplateDashboardController.url = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template_dashboard: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template_dashboard: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
    }

    return UpdateTemplateDashboardController.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
UpdateTemplateDashboardController.put = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTemplateDashboardController.url(args, options),
    method: 'put',
})

export default UpdateTemplateDashboardController